import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "feed" }
const _hoisted_2 = { class: "digest_days" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("label", null, "Pulse Digest Days", -1 /* HOISTED */)),
      _createVNode(_component_el_select_v2, {
        modelValue: $data.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.value) = $event)),
        placeholder: "Pulse Digest Days",
        multiple: "",
        filterable: "",
        clearable: "",
        remote: "",
        "multiple-limit": 30,
        options: $data.options || []
      }, null, 8 /* PROPS */, ["modelValue", "options"])
    ])
  ]))
}